import { Card, CardContent } from '../../ui/card';
import { cn } from '../../ui/cn';
import { Skeleton } from '../../ui/skeleton';

export interface PanelSkeletonProps {
  shape: 'tile' | 'chart' | 'table';
  className?: string;
}

export function PanelSkeleton({ shape, className }: PanelSkeletonProps) {
  if (shape === 'tile') {
    return (
      <Card className={className} role="status" aria-label="Loading tile">
        <CardContent className="space-y-4 p-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-3 w-28" />
        </CardContent>
      </Card>
    );
  }
  if (shape === 'chart') {
    return (
      <Card className={className} role="status" aria-label="Loading chart">
        <CardContent className="space-y-5 p-5">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-56 w-full" />
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className={cn('space-y-3 p-5', className)} role="status" aria-label="Loading table">
      <Skeleton className="h-4 w-40" />
      {Array.from({ length: 5 }, (_, index) => (
        <Skeleton key={index} className="h-8 w-full" />
      ))}
    </Card>
  );
}
